import { ReactElement, useContext } from "react";
import { IStrandProduction } from "../../../types";
import { getPalette } from "../../../configuration/configuration";
import { ReportContext } from "./productionReportContext";

interface IProps {
  productionItem: IStrandProduction;
  x: number;
  y: number;
  w: number;
  h: number;
}

const ProductionChartMachineBorder = ({ productionItem, x, y, w, h }: IProps): ReactElement | null => {
  const reportContext = useContext(ReportContext);
  const isSelected = reportContext.selected.productionMachineID === productionItem.productionMachineID || reportContext.selected.productionID === productionItem.productionID;

  if(!isSelected) {
    return null;
  }

  return (
    <>
      <line
        stroke={getPalette().statusColor.selected.background}
        strokeWidth={4}
        x1={x + 2}
        x2={x + 2}
        y1={y}
        y2={y + h}
      />
      <line
        stroke={getPalette().statusColor.selected.background}
        strokeWidth={4}
        x1={x + 2}
        x2={x + w - 4}
        y1={y + 2}
        y2={y + 2}
      />
      <line
        stroke={getPalette().statusColor.selected.background}
        strokeWidth={4}
        x1={x + 2}
        x2={x + w - 4}
        y1={y + h - 2}
        y2={y + h - 2} />
      <line
        stroke={getPalette().statusColor.selected.background}
        strokeWidth={4}
        x1={x + w - 2}
        x2={x + w - 2}
        y1={y}
        y2={y + h}/>
    </>
  );
};

export default ProductionChartMachineBorder;
